
import UnsubscriptionReportModal from "@/components/marketAnalysis/UnsubscriptionReportModal";
import EmailIcon from "@/components/marketAnalysis/icons/EmailIcon";
import WhatsappIcon from "@/components/marketAnalysis/icons/WhatsappIcon";
import { frequencyOptions } from '@/constants/settings';
import { backendExceptionHandler } from "@/mixins";
import AuthService from '@/service/AuthService';

export default {
    name: "ReportSubscriptionModal",

    components: { 
        UnsubscriptionReportModal,
        EmailIcon,
        WhatsappIcon,
    },

    mixins: [backendExceptionHandler],

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        isActivated: {
            type: Boolean,
            default: false,
        },
        isPersonalizedReport: {
            type: Boolean,
            default: false
        },
        frequency: {
            type: String,
            default: 'daily'
        }
    },

    emits: ['input', 'update:active', 'update:frequency'],

    data() {
        return {
            errorMessage: null,
            isLoading: false,
            selectedInterval: null,
            isUnsubscriptionModalOpenned: false,
        }
    },

    computed: {
        backIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/back-dark.svg') :
                require('@/assets/icons/back-light.svg');
        },
    },

    watch: {
        frequency: {
            handler(value) {
                this.selectedInterval = value;
            },
            immediate: true
        },
    },

    created() {
        this.frequencyOptions = frequencyOptions;
    },

    methods: {
        closeModal() {
            this.selectedInterval = null;
            this.$emit('input', false);
        },

        handleSelectInterval(value) {
            this.selectedInterval = value
        },

        async handleSubmit() {
            try {
                this.isLoading = true;

                if (this.isPersonalizedReport) {
                    await Promise.all([
                        AuthService.updatePersonalizedReportSubscriptionActive(this.$axios, true),
                        AuthService.updatePersonalizedReportSubscriptionPath(this.$axios, 'email'),
                        AuthService.updatePersonalizedReportSubscriptionFrequency(this.$axios, this.selectedInterval),
                    ]);
                } else {
                    await Promise.all([
                        AuthService.updateGeneralReportSubscriptionActive(this.$axios, true),
                        AuthService.updateGeneralReportSubscriptionPath(this.$axios, 'email'),
                        AuthService.updateGeneralReportSubscriptionFrequency(this.$axios, this.selectedInterval),
                    ]);
                }

                this.$emit('update:active', true);
                this.$emit('update:frequency', this.selectedInterval);
                
                this.$store.commit('snackbar/updateType', 'success');
                this.$store.commit('snackbar/updateMessage', this.isActivated ? this.$t('component.reportSubscription.editSubscriptionSuccess') : this.$t('component.reportSubscription.subscribeSuccess'));

                this.isLoading = false;
                this.closeModal();
            } catch (error) {
                this.isLoading = false;
                this.handleBackendException(error, this.isActivated ? this.$t('component.reportSubscription.editSubscriptionFail') : this.$t('component.reportSubscription.subscribeFail'));
                this.$store.commit('snackbar/updateType', 'error');
                this.$store.commit('snackbar/updateMessage', this.errorMessage);
            }
        },

        handleUnsubscribeSuccess() {
            this.$emit('update:active', false);

            this.closeModal();
        },
    },
}
